import Input from "./input";
import InputNumber from "./input-number";

export { Input, InputNumber };

export const TextArea = Input.TextArea;
export const InputSearch = Input.Search;
export const InputPassword = Input.Password;
export const InputGroup = Input.Group;
